import { Pipe, PipeTransform } from '@angular/core';
import { DprActivityGridData } from '@dpr-details/models/grid';

@Pipe({ name: 'hasDprSubActivities' })
export class HasDprSubActivitiesPipe implements PipeTransform {
  transform(data: DprActivityGridData, _: object): boolean {
    return data?.dprSubActivities?.length > 0;
  }
}
